/**
 * @pageName BlogOverview
 * @slotType dashboard plugin
 */
export type OverviewBannerParams = EmptyParams;

/** @internal */
export type EmptyParams = {};
